/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Type} from '@angular/core';
import {Button} from './button';
import {ButtonGroup} from './button-group';

export const /** @type {?} */ BUTTON_GROUP_DIRECTIVES: Type<any>[] = [Button, ButtonGroup];
